import * as Sentry from '@sentry/tanstackstart-react'
import { PostHogProvider } from 'posthog-js/react'
import { createRouter } from '@tanstack/react-router'
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query'
import * as TanstackQuery from './integrations/tanstack-query/root-provider'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2026-01-30',
} as const

// Create a new router instance
export const getRouter = () => {
  const rqContext = TanstackQuery.getContext()

  const router = createRouter({
    routeTree,
    context: { ...rqContext },
    defaultPreload: 'intent',
    Wrap: (props: { children: React.ReactNode }) => {
      return (
        <TanstackQuery.Provider {...rqContext}>
          <PostHogProvider
            apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
            options={posthogOptions}
          >
            {props.children}
          </PostHogProvider>
        </TanstackQuery.Provider>
      )
    },
  })

  if (!router.isServer) {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? (import.meta.env.DEV ? 'development' : 'production'),
      enabled: !import.meta.env.DEV,
      tracesSampleRate: 0.2,
      sendDefaultPii: true,
    })
  }

  setupRouterSsrQueryIntegration({ router, queryClient: rqContext.queryClient })

  return router
}
